import { withAuth } from './';
import axios from 'axios';

let source = null;

function cancelRequest (path) {
    source && source.cancel(path);
    source = axios.CancelToken.source();
    return source.token;
}

function getBackUrl (path, params) {
    const page = params.skip ? params.skip / 10 : 0;
    return `/${path}` + (page ? `/${page}` : '');
}

const FILTERS = {
    'my-projects':  '/projects/me',
    'aeProjects': '/projects',
    'watchlist':    '/projects/watchlist',
    'search':       '/projects',
    'reports':       '/projects',
    'aeSearch':       '/projects',
    'studioMgmt':     '/projects',
    'fepLite':       '/projects',
}

export function setEmptyProjects () {
    return dispatch => {
        dispatch({
            type: 'EMPTY_PROJECTS',
            payload: {currentPage:0},
        })
    }
}

export function fetchProjects (path, params) {
    if (typeof params === 'undefined') params = {};
    const args = { url: FILTERS[path], params }

    if (path === 'search' && !params.query) return setEmptyProjects();

    if (path === 'reports' && !params.query) return setEmptyProjects();

    if (path === 'aeSearch' && !params.query) return setEmptyProjects();

    if (path === 'aeProjects' && !params.query) return setEmptyProjects();

    if (path === 'studioMgmt' && !params.query) return setEmptyProjects();

    if (path === 'fepLite' && !params.query) return setEmptyProjects();

    return dispatch => {
        dispatch({ type: 'SET_BACK_FOR_DETAIL', payload: getBackUrl(path, params) });
        dispatch({ type: 'SET_PROJECTS_LOADING', payload: true })

        args.cancelToken = cancelRequest(path);
        withAuth(
      {method: 'get', ...args},
      (resp) => {
          resp.data.currentPage = (!params.currentPage) ? 0 : params.currentPage;
          dispatch({ type: 'FETCH_PROJECTS_FULFILLED', payload: resp });
          dispatch({ type: 'SET_PROJECTS_LOADING', payload: false });
      }
    );
    }
}

export function fetchProjectsAE (path, params) {
    if (typeof params === 'undefined') params = {};

    let url, method;
    method = 'get';
    url = `/projects/projectsAE?skip=${params.skip}`;
  
    return dispatch => {
        dispatch({ type: 'SET_BACK_FOR_DETAIL', payload: getBackUrl(path, params) });
   // dispatch({ type: 'SET_PROJECTS_LOADING', payload: true })

        withAuth(
       {method, url, data: params.data},
       (resp) => {
           resp.data.currentPage = (!params.currentPage) ? 0 : params.currentPage;
           dispatch({ type: 'FETCH_PROJECTS_FULFILLED_AE', payload: resp });
       // dispatch({ type: 'SET_PROJECTS_LOADING', payload: false });
       }
    );
    }
}

export function fetchProjectsAdvance (path, params) {

  
    let url, method;
    method = 'post';
    url = `/projects/advancesearch/?skip=${params.skip}`;
  
    return dispatch => {
        dispatch({ type: 'SET_BACK_FOR_DETAIL', payload: getBackUrl(path, params) });
        dispatch({ type: 'SET_PROJECTS_LOADING', payload: true })

        withAuth(
       {method, url, data: params.data},
      (resp) => {
          resp.data.currentPage = params.currentPage;
          dispatch({ type: 'FETCH_PROJECTS_FULFILLED', payload: resp });
          dispatch({ type: 'SET_PROJECTS_LOADING', payload: false });
      },
      (error) => {
        dispatch({ type: 'FETCH_FAILED', payload: error });
        dispatch({ type: 'SET_PROJECTS_LOADING', payload: false });
      }
    );
    }
}

export function fetchProjectsAESearch (path, params) {
    let url, method;
    method = 'post';
    url = `/projects/aesearch/?skip=${params.skip}`;
  
    return dispatch => {
        dispatch({ type: 'SET_BACK_FOR_DETAIL', payload: getBackUrl(path, params) });
        dispatch({ type: 'SET_PROJECTS_LOADING', payload: true })

        withAuth(
      {method, url, data: params.data},
      (resp) => {
          resp.data.currentPage = params.currentPage;
          dispatch({ type: 'FETCH_PROJECTS_FULFILLED', payload: resp });
          dispatch({ type: 'SET_PROJECTS_LOADING', payload: false });
      }
    );
    }
}